import * as React from 'react'
import './ErrorPanel.scss'

interface ErrorPanelProps {
  title: string
  text: string
  icon: string
  variant?: 'neutral' | 'danger'
  children?: React.ReactNode
}

export const ErrorPanel = ({ title, text, icon, variant = 'neutral', children }: ErrorPanelProps) => (
  <div className='h-50 d-flex align-items-center'>
    <div className='auth-popup-container panel-width-480'>
      <div className='auth-popup-inner auth-popup-invitation-code-expired'>
        {variant === 'danger' ? (
          <i className={`bi ${icon} danger-icon text-white d-flex justify-content-center align-items-center h-3rem w-3rem rounded-5 fs-4`} aria-hidden='true' />
        ) : (
          <div className='auth-popup-invitation-code-expired-logo'>
            <i className={`bi ${icon} fs-4`} aria-hidden='true' />
          </div>
        )}
        <div className='auth-popup-content'>
          <span className='auth-popup-title'>{title}</span>
          <span className='auth-popup-text'>{text}</span>
          {children}
        </div>
      </div>
    </div>
  </div>
)
